var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dropdown-cell",
      class:
        ((_obj = {}),
        (_obj[_vm.field.alignment] = true),
        (_obj.outlined = _vm.outlined),
        _obj),
      on: { click: _vm.enableEdit },
    },
    [
      _vm.editing
        ? [
            _c(
              "a-popover",
              {
                attrs: { trigger: "click", placement: "bottomLeft" },
                on: { visibleChange: _vm.onVisibleChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "dropdown-options" },
                            [
                              _vm.isDynamicMode
                                ? [
                                    _c("a-input-search", {
                                      attrs: {
                                        placeholder: "Search",
                                        loading: _vm.isSearching,
                                        autoFocus: "",
                                      },
                                      on: { change: _vm.handleSearchChange },
                                      model: {
                                        value: _vm.searchText,
                                        callback: function ($$v) {
                                          _vm.searchText = $$v
                                        },
                                        expression: "searchText",
                                      },
                                    }),
                                  ]
                                : [
                                    _c("a-input-search", {
                                      attrs: {
                                        placeholder: "Search",
                                        autoFocus: "",
                                      },
                                      model: {
                                        value: _vm.searchText,
                                        callback: function ($$v) {
                                          _vm.searchText = $$v
                                        },
                                        expression: "searchText",
                                      },
                                    }),
                                  ],
                              _vm._v(" "),
                              _vm.selectedOptions.length > 0
                                ? _c(
                                    "a-button",
                                    {
                                      staticClass: "clear-button",
                                      attrs: { type: "link" },
                                      on: { click: _vm.clearSelection },
                                    },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "delete" },
                                      }),
                                      _vm._v(
                                        " Clear Selection\n                    "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.displayOptions, function (option) {
                                return _c(
                                  "div",
                                  {
                                    key: option.value,
                                    staticClass: "option-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onOptionClick(option.value)
                                      },
                                    },
                                  },
                                  [
                                    _vm.isMultiple
                                      ? _c("a-checkbox", {
                                          attrs: {
                                            checked:
                                              _vm.selectedOptions.includes(
                                                option.value
                                              ),
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "option-chip",
                                        style: {
                                          backgroundColor:
                                            option.color ||
                                            "rgb(210, 216, 243)",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(option.value) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1168109258
                ),
                model: {
                  value: _vm.editing,
                  callback: function ($$v) {
                    _vm.editing = $$v
                  },
                  expression: "editing",
                },
              },
              [
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "selectedOptionsRef",
                    staticClass: "selected-options",
                  },
                  _vm._l(_vm.selectedOptions, function (option) {
                    return _c(
                      "div",
                      {
                        key: option,
                        staticClass: "option-chip",
                        style: { backgroundColor: _vm.getOptionColor(option) },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(option) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]
        : [
            _c(
              "div",
              { ref: "selectedOptionsRef", staticClass: "selected-options" },
              _vm._l(_vm.selectedOptions, function (option) {
                return _c(
                  "div",
                  {
                    key: option,
                    staticClass: "option-chip",
                    style: { backgroundColor: _vm.getOptionColor(option) },
                  },
                  [
                    _vm._v(
                      "\n                " + _vm._s(option) + "\n            "
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chevron-icons" },
              [
                _c("a-icon", { attrs: { type: "up" } }),
                _vm._v(" "),
                _c("a-icon", { attrs: { type: "down" } }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }